import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { FiArrowRight } from "react-icons/fi";
import Logo from "../logo/Logo";

const callToActionData = {
    title: "Ready to start creating a standard website?",
    subtitle: "Full-spectrum digital solutions, future-ready partnership.",
    btnText: "Free Digital Audit",
}

const CalltoActionSeven = () => {
    return (
        <div className="rn-callto-action clltoaction-style-default style-7">
            <div className="container">
                <div className="row row--0 align-items-center content-wrapper">
                    <div className="col-lg-8 col-md-8">
                        <div className="inner">
                            <div className="content text-start">
                                <Logo
                                    image={`/images/logo/WhatsOnAgencyWhite.png`}
                                    image2={`/images/logo/WhatsOn_AgencyRed.png`}
                                />
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <p className="subtitle">{callToActionData.subtitle}</p>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <div className="call-to-btn text-start mt_sm--20 text-md-end" role="list" aria-label="Compliance badges">
                               <span role="listitem"><img className="new_icons" src={`${process.env.PUBLIC_URL}/images/icons/equality.png`} alt="Equality Act compliance badge" /></span>
                               <span role="listitem"><img className="new_icons" src={`${process.env.PUBLIC_URL}/images/icons/flesh.png`} alt="Flesch Kincaid Reading Ease formula badge" /></span>
                               <span role="listitem"><img className="new_icons" src={`${process.env.PUBLIC_URL}/images/icons/wcagnew.png`} alt="WCAG 2.1, WCAG 2.2, ADA and Section 508 compliance badge" /></span>
                               <span role="listitem"><img className="new_icons" src={`${process.env.PUBLIC_URL}/images/icons/disability.png`} alt="Disability Confident Committed badge" /></span>
                                {/* <a className="btn-default btn-icon" target="_blank" href="/free-digital-audit"> {callToActionData.btnText} <i className="icon"><FiArrowRight /></i></a> */}
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CalltoActionSeven;
